type ProjectCardProps = {
  title: string;
  description: string;
  color?: string;
  repositoryLink?: string;
  liveDemoLink?: string;
};
export default function ProjectCard({
  title,
  description,
  color,
  repositoryLink,
  liveDemoLink,
}: ProjectCardProps): JSX.Element {
  const attributes =
    color &&
    ({
      style: { "--card-background-color": color } as React.CSSProperties,
    } as React.HTMLAttributes<HTMLDivElement>);
  return (
    <div className="project-card-container">
      <div className="project-card-content " {...attributes}>
        <h2 className="project-card-title">{title}</h2>
        <small className="project-card-info">{description}</small>
        <div className="project-card-row">
          {repositoryLink && (
            <a
              className="btn btn-card"
              href={repositoryLink}
              target="_blank"
              rel="noreferrer"
            >
              Link
            </a>
          )}

          {liveDemoLink && (
            <a
              className="btn btn-card"
              href={liveDemoLink}
              target="_blank"
              rel="noreferrer"
            >
              Demo
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
